export default __webpack_public_path__ + "static/media/18-ZombieDonut.98cec21c.png";